export default "__VITE_ASSET__Kc$_rXh932YpZ9rGVnRe5g__"